import { Suspense, lazy } from 'react';
import { Navigate, RouteObject } from 'react-router';

import { relativeRoutes, routes } from '@fly/shared';
import { FlyLoader } from '@fly/shared-ui';

import RuntimeEnvironments from './RuntimeEnvironments';
import { BaseBreadcrumb } from './components';
import DeploymentsSkeleton from './containers/Environment/Deployments/DeploymentsSkeleton';
import { EnvironmentBreadcrumb } from './containers/Environment/EnvironmentBreadcrumb';
import EnvironmentSkeleton from './containers/Environment/EnvironmentSkeleton';
import EnvironmentsSkeleton from './containers/Environments/EnvironmentsSkeleton';

const EnvironmentsAction = lazy(
  () => import('./containers/Environments/EnvironmentsAction')
);
const EnvironmentsPage = lazy(
  () => import('./containers/Environments/Environments')
);
const Environment = lazy(() => import('./containers/Environment/Environment'));
const Deployments = lazy(
  () => import('./containers/Environment/Deployments/Deployments')
);
const Tokens = lazy(() => import('./containers/Environment/Tokens/Tokens'));
const EnvironmentAction = lazy(
  () => import('./containers/Environment/EnvironmentAction')
);

export const environmentsRoutes: RouteObject[] = [
  {
    path: `${routes.DASHBOARD.RUNTIME_ENVIRONMENTS.ROOT}/*`,
    element: <RuntimeEnvironments />,
    handle: {
      Breadcrumb: BaseBreadcrumb,
      Action: EnvironmentsAction,
    },
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<EnvironmentsSkeleton />}>
            <EnvironmentsPage />
          </Suspense>
        ),
      },

      {
        path: `:${relativeRoutes.RUNTIME_ENVIRONMENT}`,
        element: (
          <Suspense fallback={<EnvironmentSkeleton />}>
            <Environment />
          </Suspense>
        ),
        handle: {
          Breadcrumb: EnvironmentBreadcrumb,
          Action: EnvironmentAction,
        },
        children: [
          {
            index: true,
            element: (
              <Navigate
                to={relativeRoutes.RUNTIME_ENVIRONMENTS_DEPLOYMENTS}
                replace
              />
            ),
          },
          {
            path: relativeRoutes.RUNTIME_ENVIRONMENTS_DEPLOYMENTS,
            element: (
              <Suspense fallback={<DeploymentsSkeleton />}>
                <Deployments />
              </Suspense>
            ),
          },
          {
            path: relativeRoutes.RUNTIME_ENVIRONMENTS_TOKEN,
            element: (
              <Suspense fallback={<FlyLoader />}>
                <Tokens />
              </Suspense>
            ),
          },
          {
            path: '*',
            element: (
              <Navigate
                to={`../${relativeRoutes.RUNTIME_ENVIRONMENTS_DEPLOYMENTS}`}
                replace
              />
            ),
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to={routes.DASHBOARD.RUNTIME_ENVIRONMENTS.ROOT} />,
      },
    ],
  },
];
